import { render, staticRenderFns } from "./checkbox.vue?vue&type=template&id=cad276f6&"
import script from "./checkbox.vue?vue&type=script&lang=ts&"
export * from "./checkbox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/survey-library/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cad276f6')) {
      api.createRecord('cad276f6', component.options)
    } else {
      api.reload('cad276f6', component.options)
    }
    module.hot.accept("./checkbox.vue?vue&type=template&id=cad276f6&", function () {
      api.rerender('cad276f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/checkbox.vue"
export default component.exports